






















































import { ValidationProblemDetails, WorkordersApi } from 'performo-api';
import SignaturePad from 'signature_pad';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: mapGetters({
    ordersApi: 'ordersApi'
  })
})
export default class CaptureSignature extends Vue {
  @Prop({ required: true })
  orderId!: string;

  @Prop({ required: true })
  isOrderClosedOut!: boolean;

  get buttonLabel(): string {
    if (this.signatureExists) {
      return 'View Signature';
    } else {
      return 'Capture Signature';
    }
  }

  private ordersApi!: WorkordersApi;
  private signaturePad!: SignaturePad;
  private signature!: Blob;
  private showModal = false;
  private signatureExists = false;
  private loading = false;

  private async mounted() {
    await this.setUpSignaturePad();
    await this.loadSignature();
  }

  @Watch('signatureExists')
  private disableSignaturePad() {
    if (this.signatureExists) this.signaturePad.off();
  }

  private async setUpSignaturePad() {
    this.loading = true;
    setTimeout(() => {
      // setTimeout to allow the canvas HTML element to render before setting up signature pad
      if (!this.signatureExists) {
        this.signaturePad = new SignaturePad(
          this.$refs.canvasRef as HTMLCanvasElement,
          { backgroundColor: 'rgb(255, 255, 255)' }
        );
      }
    }, 100);
    this.loading = false;
  }

  private async loadSignature() {
    this.loading = true;
    this.signature = await this.ordersApi.getSignatureByOrderId({
      orderId: this.orderId
    });
    if (this.signature.size > 0) {
      this.signatureExists = true;
      this.signaturePad.fromDataURL(
        window.URL.createObjectURL(this.signature),
        { ratio: 1, width: 550, height: 200 }
      );
      this.signaturePad.off();
    }
    this.loading = false;
  }

  @Watch('orderId')
  private async orderIdChanged() {
    this.signaturePad.clear();
    this.signatureExists = false;
    await this.loadSignature();
    await this.setUpSignaturePad();
  }

  private async saveSignature() {
    if (this.signaturePad.isEmpty()) {
      return alert('Signature is empty.');
    }
    var data = this.signaturePad.toDataURL('image/png');
    this.loading = true;
    await this.ordersApi.addSignatureToWorkorder({
      workorderAddSignatureCommand: {
        orderId: this.orderId,
        signatureDataUri: data
      }
    });
    this.signaturePad.clear();
    await this.loadSignature();
    this.$emit('signature-changed');
  }

  private async clearSignature() {
    if (this.signatureExists) {
      await this.deleteSignature();
    }
    this.signaturePad.clear();
  }

  private closeSignature() {
    this.signaturePad.clear();
    this.showModal = false;
  }

  private async deleteSignature() {
    try {
      this.loading = true;
      await this.ordersApi.deleteSignatureOnWorkorder({
        workorderDeleteSignatureCommand: { orderId: this.orderId }
      });
      this.signatureExists = false;
      this.setUpSignaturePad();
    } catch (error) {
      this.$emit('error', error as ValidationProblemDetails);
    }
  }
}
